import { Link, useNavigate } from "react-router-dom";
import { FacebookButton } from "../components/Buttons/FacebookButton";
import { GoogleButton } from "../components/Buttons/GoogleButton";
import { AuthLayout } from "../components/Layouts/AuthLayout";
import { useAuthContext } from "../context/authContext";
import { signupUserLocal } from "../api/auth";
import { Alert } from "../components/Alerts/Alert";
import { SignupForm } from "../components/Form/Forms/Auth/SignupForm";
import { motion } from "framer-motion";

export const Signup = () => {
  const { state: authState, dispatch } = useAuthContext();
  const navigate = useNavigate();

  const handleLocalSignup = (data) => signupUserLocal(data, dispatch, navigate);

  return (
    <AuthLayout>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md bg-white/90 backdrop-blur-xl rounded-3xl p-10 border border-gray-200"
      >
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">Sign up with Shippal</h2>
          <p className="mt-2 text-sm text-gray-500">Create an account to start shipping faster</p>
        </div>

        {authState?.error && <div className="mt-4"><Alert message={authState.error} /></div>}

        <div className="mt-8">
          <SignupForm onSubmit={handleLocalSignup} isLoading={authState?.isLoading} />
        </div>

        <div className="flex items-center my-6">
          <div className="flex-grow h-px bg-gray-200"></div>
          <span className="px-3 text-sm text-gray-400">or continue with</span>
          <div className="flex-grow h-px bg-gray-200"></div>
        </div>

        <div className="flex flex-col gap-3">
          <GoogleButton />
          <FacebookButton />
        </div>

        <p className="mt-8 text-center text-sm text-gray-600">
          Already have an account?{" "}
          <Link to="/login" className="text-blue font-medium hover:underline">
            Sign in
          </Link>
        </p>
      </motion.div>
    </AuthLayout>
  );
};